/**
 * Helpers for Free-form Rich Text EMR section (sectionCode: FREE_FORM_RICH_TEXT).
 * See docs/apis/emr/free-form-rich-text.md for contract.
 */

export const FREE_FORM_RICH_TEXT_SECTION_CODE = 'FREE_FORM_RICH_TEXT'

/**
 * Get free-form rich text HTML from emrSectionDataList
 * @param {Array} emrSectionDataList
 * @returns {string}
 */
export function getFreeFormRichTextFromEmrSectionDataList(emrSectionDataList) {
  if (!Array.isArray(emrSectionDataList)) return ''
  const section = emrSectionDataList.find((s) => s.sectionCode === FREE_FORM_RICH_TEXT_SECTION_CODE)
  const content = section?.subSections?.[0]?.values?.content?.valueString
  return typeof content === 'string' ? content : ''
}

/**
 * Build the EMR section data item for FREE_FORM_RICH_TEXT
 * @param {string} html - TipTap editor HTML
 * @returns {Object}
 */
export function buildFreeFormRichTextEmrSection(html) {
  const valueString = typeof html === 'string' ? html : ''
  return {
    sectionCode: FREE_FORM_RICH_TEXT_SECTION_CODE,
    subSections: [
      {
        subSectionCode: FREE_FORM_RICH_TEXT_SECTION_CODE,
        values: {
          content: {
            format: 'richtext',
            valueString,
          },
        },
      },
    ],
  }
}

/**
 * Merge free-form rich text into existing emrSectionDataList (replace or append)
 * @param {Array} emrSectionDataList
 * @param {string} freeFormHtml
 * @returns {Array}
 */
export function mergeFreeFormRichTextIntoEmrSectionDataList(emrSectionDataList, freeFormHtml) {
  const list = Array.isArray(emrSectionDataList) ? [...emrSectionDataList] : []
  const existingIndex = list.findIndex((s) => s.sectionCode === FREE_FORM_RICH_TEXT_SECTION_CODE)
  const section = buildFreeFormRichTextEmrSection(freeFormHtml)
  if (existingIndex !== -1) {
    list[existingIndex] = section
  } else {
    list.push(section)
  }
  return list
}
